export enum Role {
    Unknown = 0,
    Partner = 1,
    CaseWorker = 2,
    Admin = 3,
    SuperAdmin = 4
}
